import { render, staticRenderFns } from "./MachineAdvertLabel.vue?vue&type=template&id=a489c774&"
import script from "./MachineAdvertLabel.vue?vue&type=script&lang=js&"
export * from "./MachineAdvertLabel.vue?vue&type=script&lang=js&"
import style0 from "./MachineAdvertLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports